import { Trophy, Award, Medal, AlertCircle, UserRound } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface ProfileHeaderProps {
  name: string;
  age: number;
  profilePictureUrl?: string;
  averageScore?: number;
  birthday?: string;
}

export const ProfileHeader = ({ 
  name, 
  age, 
  profilePictureUrl,
  averageScore = 0,
  birthday
}: ProfileHeaderProps) => {
  const getProgressIcon = () => {
    if (averageScore === 0) {
      return <UserRound className="h-6 w-6 text-orange-400" />;
    }
    if (averageScore >= 90) {
      return <Trophy className="h-6 w-6 text-orange-400" />;
    }
    if (averageScore >= 80) {
      return <Award className="h-6 w-6 text-orange-400" />;
    }
    if (averageScore >= 70) {
      return <Medal className="h-6 w-6 text-orange-400" />;
    }
    if (averageScore >= 60) {
      return <AlertCircle className="h-6 w-6 text-yellow-500" />;
    }
    return <AlertCircle className="h-6 w-6 text-destructive" />;
  };

  const formatAge = (age: number) => {
    if (age === 0) {
      return "0-11 Months";
    }
    return age.toString();
  };

  return (
    <div className="flex items-start justify-between">
      <div className="flex items-center space-x-3">
        <Avatar className="h-12 w-12">
          <AvatarImage src={profilePictureUrl} alt={name} />
          <AvatarFallback>{name.charAt(0)}</AvatarFallback>
        </Avatar>
        <div>
          <h3 className="font-medium text-base">{name}</h3>
          <p className="text-sm text-muted-foreground">
            Age {formatAge(age)}
          </p>
        </div>
      </div>
      {getProgressIcon()}
    </div>
  );
};